<div class="wrapper">
  <a (click)="onDispatchEvent($event)" class="basic-click-cell" [ngClass]="{ uppercase: $safeNavigationMigration(params()?.cellOptions?.uppercase) }">{{
    $safeNavigationMigration(params()?.value) | infoDisplay
  }}</a>
</div>
